import script from "./CustomDashboardListItemDetailed.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardListItemDetailed.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardListItemDetailed.vue?vue&type=style&index=0&id=db7ea1d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db7ea1d8"]])

export default __exports__